<div class="container-fluid">
  <app-pagetitle title="Process" [breadcrumbItems]="breadCrumbItems"></app-pagetitle>
  <div class="row">
    <div class="col-lg-12">
      <div class="card">
        <div class="card-body">

          <!-- FIX: Wrapped in proper flex row with col divs -->
          <div class="row d-flex justify-content-between mb-2">
            <div class="col-md-3">
              <a class="btn btn-success mb-2" (click)="openModal(content, '', 'Add')">
                <i class="mdi mdi-plus mr-2"></i> Add Process
              </a>
            </div>
            <div class="col-md-9 d-flex justify-content-end">
              <div class="mr-2">
                <input
                  type="text"
                  class="form-control"
                  placeholder="Search..."
                  [(ngModel)]="searchTerm"
                />
              </div>
              <div>
                <button class="btn btn-primary" title="Back" (click)="goBack()">
                  Back
                </button>
              </div>
            </div>
          </div>

          <!-- Table -->
          <!-- FIX: slice: pageSize : pageSize + itemsPerPage for correct pagination window -->
          <div class="table-responsive mt-3" *ngIf="processData?.length > 0; else noData">
            <table
              class="table table-striped table-bordered table-centered dt-responsive nowrap"
              style="border-collapse: collapse; border-spacing: 0; width: 100%"
            >
              <thead class="thead-dark">
                <tr>
                  <th>Process</th>
                  <th style="width: 120px">Action</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  *ngFor="
                    let item of processData
                      | filter: searchTerm
                      | slice: pageSize : pageSize + itemsPerPage;
                    let i = index
                  "
                >
                  <td>{{ item.processName }}</td>
                  <td>
                    <a
                      class="text-primary mr-2"
                      title="Edit"
                      style="cursor: pointer"
                      (click)="openModal(content, item, 'Edit')"
                    >
                      <i class="mdi mdi-pencil font-size-18"></i>
                    </a>
                    <a
                      class="text-danger"
                      title="Delete"
                      style="cursor: pointer"
                      (click)="openModalDelete(deletetemp, item)"
                    >
                      <i class="mdi mdi-trash-can font-size-18"></i>
                    </a>
                  </td>
                </tr>
              </tbody>
            </table>

            <!-- FIX: processData (lowercase) instead of ProcessData -->
            <div class="col-md-6" *ngIf="processData?.length > itemsPerPage">
              <ngb-pagination
                class="pagination-rounded"
                [collectionSize]="processData?.length"
                [pageSize]="itemsPerPage"
                [(page)]="currentPage"
                [maxSize]="1"
                [rotate]="true"
                [ellipses]="false"
                [boundaryLinks]="true"
                (pageChange)="onPageChange($event)"
              >
              </ngb-pagination>
            </div>
          </div>

          <!-- No Data -->
          <ng-template #noData>
            <div class="card p-3">
              <span>
                <strong>{{ errmsg || 'No Process Found. Please Add Process' }}</strong>
              </span>
            </div>
          </ng-template>

        </div>
      </div>
    </div>
  </div>
</div>

<!-- Add/Edit Modal -->
<ng-template #content role="document" let-modal="close">
  <div class="modal-header">
    <h5 class="modal-title">{{ action }} Process</h5>
    <button type="button" class="close" (click)="modal('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body card-body">

    <!-- FIX: Moved input outside custom-switch; added proper label and validation -->
    <div class="form-group">
      <label for="processName">Process Name <span class="text-danger">*</span></label>
      <input
        type="text"
        class="form-control"
        id="processName"
        placeholder="Enter process name"
        [(ngModel)]="processName"
        [ngClass]="{ 'is-invalid': submitted && !processName }"
      />
      <!-- FIX: Added validation error message -->
      <div *ngIf="submitted && !processName" class="invalid-feedback">
        Process name is required.
      </div>
    </div>

    <div class="mt-4">
      <button
        type="button"
        class="btn btn-primary round waves-effect"
        (click)="saveprocess()"
      >
        {{ action }}
      </button>
      &nbsp;
      <button
        type="button"
        class="btn btn-secondary round waves-effect"
        (click)="modal('Cross click')"
      >
        Cancel
      </button>
    </div>
  </div>
</ng-template>

<!-- Delete Modal -->
<ng-template #deletetemp role="document" let-modal="close">
  <div class="modal-header">
    <h5 class="modal-title">Delete Process</h5>
    <button type="button" class="close" (click)="modal('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body card-body">
    <p>Are you sure you want to delete this process?</p>
    <button
      type="button"
      class="btn btn-danger round waves-effect"
      (click)="delete(delprocessId)"
    >
      Delete
    </button>
    &nbsp;
    <button
      type="button"
      class="btn btn-info round waves-effect"
      (click)="modal('Cross click')"
    >
      Cancel
    </button>
  </div>
</ng-template>